/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Modal_Unavailable_TitleInputs */

const en_task_modal_unavailable_title = /** @type {(inputs: Task_Modal_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity unavailable`)
};

const pt_br2_task_modal_unavailable_title = /** @type {(inputs: Task_Modal_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade indisponível`)
};

/**
* | output |
* | --- |
* | "Activity unavailable" |
*
* @param {Task_Modal_Unavailable_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_modal_unavailable_title = /** @type {((inputs?: Task_Modal_Unavailable_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Modal_Unavailable_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_modal_unavailable_title(inputs)
	return pt_br2_task_modal_unavailable_title(inputs)
});